<template>
  <div id="zarpe-page">
    <Zarpe />
  </div>
</template>

<script>
import Zarpe from '../components/Zarpe.vue'

export default {
  name: 'ZarpePage',
  components: {
    Zarpe
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/Zarpe.vue